import xieyi from '@/components/xieyi'
import AutoForm from '@/components/AutoForm'

export default {
  components: {
    xieyi, AutoForm
  },
  props: {},
  data() {
    // 再次输入密码验证
    let validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.registerForm.Password) {
        callback(new Error('两次输入的密码不一致!'));
      } else {
        callback();
      }
    };
    // 证件号码格式验证
    let validateConfirmIdCard = (rule, value, callback) => {
      switch (this.form.ContractsCardType) {
        case 0: //
          validateIdCard(rule, value, callback);
          break;
        case 1:
          validatePassport(rule, value, callback);
          break;
        case 2:
          validateMilitaryCard(rule, value, callback);
          break;
        case 9:
          validateHMPassCard(rule, value, callback);
          break;
      }
    };
    // 短信验证码
    let VcodeRegex = (rule, value, callback) => {
      if (value != '123456') {
        callback(new Error('验证码不正确'));
      } else {
        callback();
      }
    }

    let validateCutomname = (rule, value, callback) => {
      var self = this;
      self.$http.post(self.url.vUserName, {
        Data: self.registerForm.Name
      }).then(result => {
        if(!result){
          callback(new Error('用户名称已存在，换一个吧~'));
        }else{
          callback();
        }
      }, () => {

      });
    };

    return {
      xieyiVisible: false,
      url: {
        save:SZH.assets.api + '/Login/RegisterAccount',
        SendVerifyCodeForRegister:SZH.assets.api + '/Login/SendVerifyCodeForRegister'
      },
      checked:true,
      registerForm:{
        Name:'',
        UserName:'', // 登录账号
        Password:'', // 登录密码
        RePassword:'', // 确认密码
        PhoneNumber:'', // 手机号
        Vcode:'', // 短信验证码
        SMSKey:''
      },
      rules: {
        Captcha: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          }
        ],
        UserName: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur'
          },
          {
            min: 6,
            max: 25,
            message: '登录账号长度应在 6 到 25 个字符之间',
            trigger: 'blur'
          },
          {
            validator: validateUsername,
            trigger: 'blur'
          }
        ],
        Password: [
          {
            required: true,
            message: '请输入登录密码',
            trigger: 'blur'
          },
          {
            validator: validatePassword,
            trigger: 'blur'
          }
        ],
        RePassword: [
          {
            required: true,
            message: '请再次输入密码',
            trigger: 'blur'
          },
          {
            validator: validateConfirmPassword,
            trigger: 'blur'
          }
        ],
        PhoneNumber: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            validator: validatePhone,
            trigger: 'blur'
          }
        ],
        Vcode: [
          {
            required: true,
            message: '请输入短信验证码',
            trigger: 'blur'
          },
          {
            min: 6,
            max: 6,
            message: '短信验证码长度应为6个字符',
            trigger: 'blur'
          }
        ],

      },
      checkbox: true,
      loading: null,
      userNameIsOk: false,
      customNameIsOk: false,
      btnName:'获取验证码',
      setintIndex:null,
      sendVCodeTime:59,
      fullscreenLoading:false,
      disBtn:false
    }
  },
  methods: {
    turnTo(url){
      this.$router.push({
        path:url
      })
    },
    register() {
      var self = this;
      if(!self.checkbox){
        self.$message.error('请阅读并同意《服务协议》后再进行后续操作！');
      }else{
        self.$refs['registerForm'].validate((valid) => {
          if (valid) {
            self.fullscreenLoading = true;
            self.registerForm.Name = self.registerForm.UserName;
            self.registerForm.Password = hex_md5(self.registerForm.Password);
            self.registerForm.RePassword = hex_md5(self.registerForm.RePassword);
            self.$http.post(self.url.save,  self.registerForm)
              .then(result => {
                if (result.state == true) { // 注册成功
                  self.$message.success('恭喜您，注册成功!');
                  self.$router.push({
                    path:'/LoginTH'
                  })
                } else {
                  self.$message.error(result.message);
                  // self.refreshCaptcha();
                }
                self.fullscreenLoading = false;
              }, () => {
                // 请求失败
                self.$message.error('注册失败，请检查您的网络是否可用。');
                self.fullscreenLoading = false;
              });
          } else {
            return false;
          }
        });
      }
    },
    getCode(){
      let self = this;
      if(!self.registerForm.PhoneNumber){
        self.$message.error('请输入手机号！');
        return
      }
      self.disBtn = true;
      //如果存在定时器不再调用接口
      if(self.setintIndex){
        return
      }
      //TODO
      self.sendVerifyCodeForRegisterFun();
      //调用接口成功调用下面的方法

    },
    sendVerifyCodeForRegisterFun(){
      let self = this;
      self.$http.post(self.url.SendVerifyCodeForRegister, {
        Phone:self.registerForm.PhoneNumber
      }).then(result => {
          if (result.state == true) {
            self.$message.success('短信发送成功!');
            self.registerForm.SMSKey = result.data;
            self.getReturnTime();
          } else {
            self.disBtn = false;
            self.$message.error(result.message);
          }
        }, () => {
          // 请求失败
          self.$message.error('注册失败，请检查您的网络是否可用。');
        });
    },
    getReturnTime(){
      this.btnName = '倒计时:'+this.sendVCodeTime+'s';
      this.setintIndex = setInterval(()=>{
        --this.sendVCodeTime;
        this.btnName = '倒计时:'+this.sendVCodeTime+'s';
        if(this.sendVCodeTime == 0){
          window.clearInterval(this.setintIndex);
          this.setintIndex = null;
          this.disBtn = false;
          this.btnName = '获取验证码';
          this.sendVCodeTime = 59;
        }
      },1000)
    }
  },
  computed: {
  },
  created() {
  },
  mounted() {
    clearInterval(this.setintIndex);
  },
  watch: {}
}



// WEBPACK FOOTER //
// ./src/views/RegisterTH/RegisterTH.js